var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoundOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.762,
    height: 22.748,
    viewBox: "0 0 22.762 22.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13.12 -12.209)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(362.237 -607.027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.088,10.884q0,5,0,9.992c0,.086,0,.173,0,.259a.605.605,0,0,1-1.018.442c-.073-.06-.141-.127-.21-.193q-2.934-2.771-5.871-5.538a.581.581,0,0,0-.362-.139C3.343,15.7,2.063,15.7.783,15.7c-.57,0-.782-.213-.782-.783q0-4.049,0-8.1c0-.57.213-.782.783-.782,1.263,0,2.526,0,3.789,0a.6.6,0,0,0,.458-.177q2.945-2.8,5.9-5.581a1.466,1.466,0,0,1,.24-.2.586.586,0,0,1,.881.367,1.672,1.672,0,0,1,.033.386Q12.09,5.863,12.088,10.884Zm-1.241,8.827V2.034c-.1.1-.172.159-.241.223Q8.153,4.574,5.7,6.895a1.163,1.163,0,0,1-.878.354C3.717,7.231,2.609,7.242,1.5,7.242H1.225V14.5h.3c1.09,0,2.181.013,3.271-.007a1.2,1.2,0,0,1,.924.372c.776.754,1.568,1.49,2.355,2.233Z",
    transform: "translate(-348.618 619.742)",
    fill: "inherit",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    className: "stroke"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 5.893,
    y2: 5.893,
    transform: "translate(27.555 20.641)",
    fill: "none",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.893,
    y2: 5.893,
    transform: "translate(27.555 20.641)",
    fill: "none",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundOff);
export default __webpack_public_path__ + "static/media/sound_off.7b935867428ec3f6c5d6798625839e3c.svg";
export { ForwardRef as ReactComponent };